import type { IDocumentsTreeRow } from '../../lib/buildDocumentsTreeGroups'
import { EltDocumentsTable } from '../eltDocumentsList/EltDocumentsTable'
import { QbrDocumentsTable } from '../qbrDocumentsList/QbrDocumentsTable'

import styles from './DocumentsTreeTable.module.scss'

export const DocumentsTreeTable = ({
  rows,
  readOnly,
}: {
  rows: IDocumentsTreeRow[]
  readOnly: boolean
}) => {
  const partnerId = rows[0]?.partnerId ?? ''
  const partnerIds = new Map(rows.map((row) => [row.document, row.partnerId]))
  const eltDocuments = rows.flatMap((row) => (row.type === 'elt' ? [row.document] : []))
  const qbrDocuments = rows.flatMap((row) => (row.type === 'qbr' ? [row.document] : []))
  return (
    <div className={styles.root}>
      {eltDocuments.length > 0 && (
        <EltDocumentsTable
          partnerId={partnerId}
          documents={eltDocuments}
          readOnly={readOnly}
          showPartnerId
          getPartnerId={(document) => partnerIds.get(document) ?? partnerId}
        />
      )}
      {qbrDocuments.length > 0 && (
        <QbrDocumentsTable
          partnerId={partnerId}
          documents={qbrDocuments}
          readOnly={readOnly}
          showPartnerId
          getPartnerId={(document) => partnerIds.get(document) ?? partnerId}
        />
      )}
    </div>
  )
}
